import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

declare global {
  interface Window { AjaxZip3: any; }
}

interface mCompany {
  company_name:     string;
  company_kana:     string;
  zip_cd:           string;
  address1:         string;
  address2:         string;
  address3:         string;
  tel:              string;
  fax:              string;
  homepage_url:     string;
  industry_kbn:     number;
  free_expired_at:  string;
  gcs_company_code: string;
  gcs_note:         string;
  view_free_expired_at: string;
  certificate_password: string;
  certificate_file: File;
  is_certificate_file_upload: boolean;
  is_certificate_password: boolean;
}

interface radio {
  label: string
  value: number
}

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // 企業テンプレート
  let mCompany = {
    company_name:     null,
    company_kana:     null,
    zip_cd:           null,
    address1:         null,
    address2:         null,
    address3:         null,
    tel:              null,
    fax:              null,
    homepage_url:     null,
    industry_kbn:     0,
    free_expired_at:  null,
    gcs_company_code: null,
    gcs_note:         null,
    view_free_expired_at: null,
    certificate_password: null,
    is_certificate_file_upload: false,
    is_certificate_password: false,
  } as mCompany

  // 業種区分
  let industryKbns: radio[] = [
    { label: "運営会社", value: 0},
    { label: "保険薬局", value: 1},
    { label: "医療機関", value: 2}
  ]

  // テンプレート内容
  const [ company, setCompany] = useState<mCompany>(mCompany);

  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 証明書アップロード
  const fileInputRef = useRef(null);
  const [uploadFile, setUploadFile] = useState<File | null>(null);

  // 初回ロード
  useEffect(() =>{
    if (props.is_edit){
      setIsLoading(true);
      axios.get(
        '/api/internal/companies/get_company?id=' + props.m_company_id, {})
      .then(function (response) {
        setCompany(response.data.m_company);
      }).catch(error => {

      }).finally(() => {
        setIsLoading(false);
      });
    }
  },[]);

  useEffect(() =>{
    setCompany({...company, free_expired_at: company.view_free_expired_at})
  },[company.view_free_expired_at]);

  // 企業登録・更新
  const submitCompany = async() => {
    setIsLoading(true);
    const form_data = await createFormDate(uploadFile);
    if (props.is_edit){
      axios.post(
        '/api/internal/companies/update', form_data , { headers: {'content-type': 'multipart/form-data'}})
      .then(function (response) {
        location.href = ("/company/index");
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }else{
      axios.post(
        '/api/internal/companies/create', form_data , { headers: {'content-type': 'multipart/form-data'}})
      .then(function (response) {
        location.href = ("/company/index");
      }).catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }

  // ラジオボタンの変更
  const changeIndustryKbn = (event: React.ChangeEvent<HTMLInputElement>) => setCompany({...company, industry_kbn: Number(event.target.value)});
    
  // 住所取得成功時
  window.AjaxZip3.onSuccess = function() {
    const address1 = document.getElementById('m_company_address1') as HTMLInputElement;
    const address2 = document.getElementById('m_company_address2') as HTMLInputElement;
    setCompany({...company, address1: address1.value, address2: address2.value});
  }

  // 証明書アップロード
  const fileUpload = () => {
    fileInputRef.current.click();
  }
  // 証明書選択
  const selectFile = (e) => {
    const files = e.target.files
    if(files && files[0]){
      setUploadFile(files[0]);
    }
  }

  const createFormDate = (file) => {
    const form_data = new FormData();
    
    if(file){
      form_data.append('certificate_file', file);
    }
    
    for (let key in company) {
      if (company[key] === null) {
        continue;
      }
      form_data.append(`m_company[${key}]`, company[key]);
    }

    return form_data
  }

  // パスワード表示
  function viewPassword(checked){
    const company_password = document.getElementById('m_company_certificate_password');
    if(checked){
      company_password.setAttribute('type', 'text');
    }else{
      company_password.setAttribute('type', 'password');
    }
  }
  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }

      <div className="form-group">
        <label htmlFor="m_company_company_name">企業名</label><span className="label label-danger ml5">必須</span>
        <input className="form-control" placeholder="株式会社グッドサイクルシステム" type="text" id="m_company_company_name" value={company.company_name} defaultValue={company.company_name} onChange={(e) => setCompany({...company, company_name: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_company_kana">企業名(カナ)</label>
        <input className="form-control" placeholder="カブシキガイシャグッドサイクルシステム" type="text" id="m_company_company_kana" value={company.company_kana} defaultValue={company.company_kana} onChange={(e) => setCompany({...company, company_kana: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_zip_cd">郵便番号</label>
        <div className="form-inline">
          <input className="form-control mr10" name="zip_cd" placeholder="999-9999" type="text" id="m_company_zip_cd" value={company.zip_cd} defaultValue={company.zip_cd} onChange={(e) => setCompany({...company, zip_cd: e.target.value})}/>
          <button className="btn btn-info" name="button" type="button" onClick={() => window.AjaxZip3.zip2addr('zip_cd','','address1','address2')}>〒 → 住所</button>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_address1">住所</label>
        <input className="form-control" name="address1" placeholder="東京都" type="text" id="m_company_address1" value={company.address1} defaultValue={company.address1} onChange={(e) => setCompany({...company, address1: e.target.value})}/>
        <input className="form-control" name="address2" placeholder="中央区八丁堀" type="text" id="m_company_address2" value={company.address2} defaultValue={company.address2} onChange={(e) => setCompany({...company, address2: e.target.value})}/>
        <input className="form-control" name="address3" placeholder="三丁目10番1号" type="text" id="m_company_address3" value={company.address3} defaultValue={company.address3} onChange={(e) => setCompany({...company, address3: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_tel">電話番号</label>
        <input className="form-control" placeholder="03-0000-0000" type="text" id="m_company_tel" value={company.tel} defaultValue={company.tel} onChange={(e) => setCompany({...company, tel: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_fax">fax番号</label>
        <input className="form-control" placeholder="03-0000-1111" type="text" id="m_company_fax" value={company.fax} defaultValue={company.fax} onChange={(e) => setCompany({...company, fax: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_homepage_url">ホームページURL</label>
        <input className="form-control" placeholder="ホームページURL" type="text" id="m_company_homepage_url" value={company.homepage_url} defaultValue={company.homepage_url} onChange={(e) => setCompany({...company, homepage_url: e.target.value})}/>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_industry_kbn">業種区分</label>
        <div className="radio-inline">
          { industryKbns.map((industryKbn) =>{
            return (
              <>
                <input checked={industryKbn.value === company.industry_kbn}　className="radio-input" type="radio" name="m_company[industry_kbn]" value={industryKbn.value} id={`m_company_industry_kbn_${industryKbn.value}`} onChange={changeIndustryKbn}/>
                <label className="m10" htmlFor={`m_company_industry_kbn_${industryKbn.value}`}>{industryKbn.label}</label>
              </>
            )}) 
          }
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_free_expired_at">SMS送信無料期間終了日</label>
        <div className="form-inline">
          <input className="form-control" placeholder="YYYY/MM/DD" type="date" id="m_company_free_expired_at" value={company.free_expired_at} defaultValue={company.free_expired_at} onChange={(e) => setCompany({...company, free_expired_at: e.target.value})}/>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="m_company_gcs_company_code">企業コード</label><span className="label label-danger ml5">必須</span>
        <input className="form-control" autoComplete="off" placeholder="企業コード" type="text" id="m_company_gcs_company_code" value={company.gcs_company_code} defaultValue={company.gcs_company_code} onChange={(e) => setCompany({...company, gcs_company_code: e.target.value})}/>
      </div>

      <div className="form-group">
        <label>証明書アップロード</label>
          { company.is_certificate_file_upload ? (
            <>
              <span className="red font_size_s">再度アップロードが必要な場合は一度証明書を削除して下さい。</span>
              <br/>
              <span className="label label-success">アップロード済  </span>
            </>
          ):(
            <div className="form-inline">
              <div className="felx_center">
                <div className="col-md-8">
                  { uploadFile ? uploadFile.name : "ファイルを選択してください"}
                </div>
                <div className="col-md-4">
                  <button className="btn btn-info" name="button" type="button" onClick={fileUpload}>ファイルを選択</button>
                  <input className="display-none" ref={fileInputRef} id="upload_file" type="file" accept=".pfx" onChange={selectFile}/>
                </div>
              </div>
            </div>
          )}

      </div>

      <div className="form-group">
        <label htmlFor="m_company_certificate_password">証明書パスワード</label>
        {
          company.is_certificate_password && (
            <span className="red font_size_s">パスワードを変更したい場合は入力して下さい。</span>
          )
        }
        <input className="form-control" name="install-password" autoComplete="new-password" placeholder="証明書パスワード" type="password" id="m_company_certificate_password" value={company.certificate_password} defaultValue={company.certificate_password}onChange={(e) => setCompany({...company, certificate_password: e.target.value})}/>
        <div className="felx_center">
          <input className="mt0" type="checkbox" id="show_password" onChange={(e) => viewPassword(e.target.checked)} />
          <label className="font_size_s mb0" htmlFor="show_password">パスワードを表示する</label>
        </div>
            

      </div>

      <div className="form-group">
        <label htmlFor="m_company_gcs_note">GCS用備考欄（GCS用管理画面のみ使用）</label>
        <textarea className="form-control" rows={15} placeholder="GCS用備考欄（GCS用管理画面のみ使用）" id="m_company_gcs_note" value={company.gcs_note}  defaultValue={company.gcs_note} onChange={(e) => setCompany({...company, gcs_note: e.target.value})}/>
      </div>

      {/* ボタン類 */}
      <div>
        <div className="actions mt40">
          <a className="btn btn-primary pull-left m5" href="/company/index">戻る</a>
          <a className="btn btn-primary pull-right m5" type="hidden" data-toggle="modal" data-target="#company_form_modal">
            {(props.is_edit) ? ("更新する") : ("登録する") }
          </a>
        </div>
      </div>

      {/* 登録・更新確認 */}
      <div className="modal fade" data-backdrop="static" id="company_form_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>{(props.is_edit) ? ("更新する") : ("登録する") }</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
            {(props.is_edit) ? ("この内容で更新します") : ("この内容で登録します") }
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={ submitCompany }
          >
          {(props.is_edit) ? ("更新する") : ("登録する") }
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </LoadingOverlay>
    )
}
export default Index;